import { Col, Row } from "reactstrap";
import "utils/jsdocTypes";

/**
 * @typedef {Object} Props
 * @property {string} companyName
 * @property {string} address1
 * @property {string} [address2]
 * @property {string} city
 * @property {string} state
 * @property {string} zip
 * @property {string} imgUrl
 */

/**
 * @function InvoiceHeader
 * @param {Props} props
 * @type {React.JSX.Element}
 */
const InvoiceHeader = ({
  companyName,
  address1,
  address2,
  city,
  state,
  zip,
  imgUrl,
}) => {
  return (
    <Row>
      <Col sm="6">
        <div>
          <span className="invoiceAddressName">{companyName}</span>
        </div>
        <div>
          <span>{address1}</span>
        </div>
        {address2 && (
          <div>
            <span>{address2}</span>
          </div>
        )}
        <div>
          <span>
            {city}, {state} {zip}
          </span>
        </div>
      </Col>

      <Col sm="6" className="d-flex justify-content-end align-items-center">
        <img className="invoiceLogo" src={imgUrl} crossOrigin="anonymous" />
      </Col>
    </Row>
  );
};

export default InvoiceHeader;
